// extracted by mini-css-extract-plugin
export default {"container":"compare-dropdown_container__7XJ7m"};